import { useState } from "react";
import { useDispatch } from "react-redux";
import { updatePassword } from "../../../services/authService";
import MultipleAccountsModal from "./MultipleAccountsModal";

const useProfilePasswordUpdate = () => {
  const dispatch = useDispatch();
  const [pendingConfirmation, setPendingConfirmation] = useState(null);
  const [loading, setLoading] = useState(false);

  const submitPasswordUpdate = async (
    values,
    onSuccess,
    confirmAllAccounts = false,
  ) => {
    setLoading(true);
    try {
      const result = await dispatch(
        updatePassword({
          ...values,
          ...(confirmAllAccounts ? { confirmAllAccounts: true } : {}),
        }),
      ).unwrap();

      if (result?.requiresAccountConfirmation) {
        setPendingConfirmation({ data: result.data, values, onSuccess });
        return;
      }

      if (result?.success) {
        setPendingConfirmation(null);
        onSuccess?.();
      }
    } catch (error) {
      // The auth slice displays the rejected thunk error.
    } finally {
      setLoading(false);
    }
  };

  const confirmationModal = pendingConfirmation ? (
    <MultipleAccountsModal
      email={pendingConfirmation.data.email}
      accountCount={pendingConfirmation.data.accountCount}
      roles={pendingConfirmation.data.roles}
      loading={loading}
      onCancel={() => setPendingConfirmation(null)}
      onContinue={() =>
        submitPasswordUpdate(
          pendingConfirmation.values,
          pendingConfirmation.onSuccess,
          true,
        )
      }
    />
  ) : null;

  return {
    confirmationModal,
    loading,
    submitPasswordUpdate,
  };
};

export default useProfilePasswordUpdate;
